import numberFormatter from '../numberFormatter';
/**
 * @param {number} [num]
 * @return {string}
 */

var intFormatter = function intFormatter(num) {
  return numberFormatter(num, 0);
};

export default intFormatter;